module.exports = __webpack_public_path__ + "assets/img/DigitalPictogram_TWITTER.7e145c9e.svg";